import { connect } from 'react-redux'
import Loader from './Loader'
import { areRequestsLoading } from '../../selectors/ui'

const mapStateToProps = (state, ownProps) => ({
  isLoading: areRequestsLoading(state, ownProps.requests)
})

export default connect(mapStateToProps)(Loader)
